
import { useState } from "react"
import { Tooltip, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { formatDinero } from "./../../../utils/formatDinero"
import { FormatoFechaIso } from "./../../../utils/FormatFecha"
import { useSelector, useDispatch } from "react-redux"
import EstatusReserva from "../Estatus"
import FReserva from "../FPagarReserva"
import FAutorizacion from "../FAutorizar"
import { obtenerReservasPaginaAction, obtenerReservasRegistrosAction } from "./../../../ducks/reservasExpiradasDuck"
import BackDrop from "../../../global/BackDrop"
import { EstatusCompra } from "../../../constant/catEstatusCompra"
import ButtonClienteDetalle from "./../../../global/ButtonClienteDetalle"
import Avance from "../../../global/Avance"
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import EventBusyIcon from '@material-ui/icons/EventBusy'
import {offLoadAction, onLoadAnction} from "./../../../ducks/loadDuck"
const columns = [
    { id: "referencia", minWidth: 50, align: "center", label: "Referencia" },
    { id: "nombre", minWidth: 50, align: "center", label: "Nombre" },
    { id: "paquete", minWidth: 50, align: "center", label: "Paquete" },
    { id: "salida", minWidth: 50, align: "center", label: "Salida" },
    { id: "np", minWidth: 50, align: "center", label: "Pax" },
    { id: "montoPaquete", minWidth: 50, align: "center", label: "Monto" },
    { id: "ahorro", minWidth: 50, align: "center", label: "Ahorro" },
    { id: "porcentaje", minWidth: 50, align: "center", label: "%" },
    { id: "corriente", minWidth: 50, align: "center", label: "Corriente" },
    { id: "estatus", minWidth: 50, align: "center", label: "Estatus" },
    { id: "version", minWidth: 50, align: "center", label: "Versión" },
    { id: "accion", minWidth: 50, align: "center", label: "Acción" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TReservasExpiradas = () => {
    const { reservas, total, pagina, registroPagina } = useSelector(store => store.reservasExpirdas)
    const rows = reservas ?? []
    const classes = useStyles()
    const dispatch = useDispatch()
    const [load, setLoad] = useState(false)
    const handleChangePage = (event, newPage) => {
        dispatch(onLoadAnction({message: ""}))
        dispatch(obtenerReservasPaginaAction({ Pagina: newPage })).then(Response => {
            dispatch(offLoadAction())
        })
    }

    const handleChangeRowsPerPage = (event) => {
        setLoad(true)
        dispatch(obtenerReservasRegistrosAction({ Registros: +event.target.value })).then(Response => {
            setLoad(false)
        })
    }
    return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row?.Meta?.Id_Meta}>
                                        <TableCell align='center'>
                                            <ButtonClienteDetalle referencia={row?.Meta?.Referencia} />
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row?.Meta?.contratacion?.Cliente}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row?.Meta?.Paquete?.Nombre}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {FormatoFechaIso({ date: row?.Meta?.Paquete?.Fecha_Viaje })}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.Meta?.Paquete?.Numero_Personas}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row?.Meta?.Paquete?.Monto_Paquete)} ${row?.Meta?.Paquete?.Cotizacion?.Moneda?.Clave}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row?.Meta?.Paquete?.Cotizacion?.Suma)} ${row?.Meta?.Paquete?.Cotizacion?.Moneda?.Clave}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Avance progress={row?.Meta?.Paquete?.Cotizacion?.Avance} label={false} />
                                        </TableCell>
                                        <TableCell align="center">
                                            <div style={{display: "flex", justifyContent: "center", alignItems: "center", flexFlow: "column"}}>
                                                {
                                                    row?.Meta?.Paquete?.AlCorriente ? <EventAvailableIcon color="secondary" /> : <EventBusyIcon color="error" />
                                                }
                                                {(row?.Meta?.Paquete?.AlCorriente) ? `Al corriente` : "Con atraso"}
                                            </div>
                                        </TableCell>
                                        <TableCell align="center">
                                            <EstatusReserva estatus={row?.Compra?.estatusCompra?.idEstatusCompra} />
                                        </TableCell>
                                        <TableCell align="center">
                                            <Tooltip title={row?.Meta?.Paquete?.ClaveVersion}>
                                                <div>
                                                    {row?.Meta?.Paquete?.ClaveVersion.substring(row?.Meta?.Paquete?.ClaveVersion.length - 2)}
                                                </div>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell align="center">
                                            {
                                                (!row?.DscEstatus && row?.Compra?.estatusCompra?.idEstatusCompra === EstatusCompra.NoAplica) &&
                                                <FReserva
                                                    idMoneda={row?.Meta?.Paquete?.MonedaProveedor?.id_moneda}
                                                    idCuenta={row?.Meta?.Paquete?.cuenta?.Id_Cuenta}
                                                    idPaquete={row?.Meta?.Paquete?.Id_Paquete}
                                                    Referencia={row?.Meta?.Referencia}
                                                    disabled={(row?.Compra?.estatusCompra?.idEstatusCompra !== EstatusCompra.NoAplica) ? true : false}
                                                />
                                            }
                                            {
                                                (row?.DscEstatus) ? row?.DscEstatus : ""
                                            }
                                            {
                                                (row?.Compra?.estatusCompra?.idEstatusCompra === EstatusCompra.APROBADO_CLIENTE ||
                                                    row?.Compra?.estatusCompra?.idEstatusCompra === EstatusCompra.FONDOS_INSUFICIENTES 
                                                    && !row?.DscEstatus) &&
                                                <FAutorizacion
                                                    Compra={row?.Compra}
                                                    Moneda={row?.Meta?.Paquete?.MonedaProveedor}
                                                    estatus={row?.Compra?.estatusCompra?.idEstatusCompra}
                                                    disabled={(row?.Compra?.estatusCompra?.idEstatusCompra !== EstatusCompra.APROBADO_CLIENTE &&
                                                        row?.Compra?.estatusCompra?.idEstatusCompra !== EstatusCompra.FONDOS_INSUFICIENTES
                                                    )}
                                                />
                                            }
                                        </TableCell>

                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={total}
                    rowsPerPage={registroPagina}
                    page={pagina}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <BackDrop open={load} />
        </div>
    )
}
export default TReservasExpiradas